export { default } from "./ProcesamientoCSV";
